<template>
  <v-btn-toggle>
    <slot>
      <v-btn v-if="showIcons" color="default" small :to="editLink" icon>
        <v-icon>{{ mdiPencil }}</v-icon>
      </v-btn>
      <v-btn v-else color="default" small :to="editLink">
        {{ $t('common.buttons.edit') }}
      </v-btn>
      <v-btn v-if="showIcons" color="error" small @click="remove(item)">
        <v-icon>{{ mdiDelete }}</v-icon>
      </v-btn>
      <v-btn v-else color="error" small @click="remove(item)">
        {{ $t('common.buttons.delete') }}
      </v-btn>
    </slot>
    <slot name="append" />
  </v-btn-toggle>
</template>

<script>
import { mdiDelete, mdiPencil } from '@mdi/js';

export default {
  name: 'TableBasicButtons',
  props: {
    item: {
      type: Object,
      default: undefined,
    },
    editLink: {
      type: Object,
      default: undefined,
    },
    showIcons: {
      type: Boolean,
      defaultStatus: true,
    },
    deleteMessage: {
      type: String,
      default: undefined,
    },
  },
  data() {
    return {
      // icons
      mdiDelete,
      mdiPencil,
    };
  },
  methods: {
    remove(item) {
      this.$confirm(
        this.deleteMessage ?? this.$t('common.phrases.confirmDelete'),
      ).then((confirm) => {
        if (confirm) {
          this.$emit('delete', item);
        }
      });
    },
  },
};
</script>
